<template>
    <el-main class="site-content">
        <div class="documents-page">
            <div class="documents-page-head">
                <div class="documents-page-head__inner">
                    <div class="container">
                        <el-row :gutter="12" type="flex" align="middle">
                            <el-col :span="12">
                                <h2 class="wizard-step-head__title">Документы</h2>
                            </el-col>

                            <el-col :span="6" class="documents-page-head__grow">
                                <div class="documents-page-head__extra">
                                    <v-select class="select" placeholder="Тип документа" v-model="curType" :clearable="false" :options="documentTypes">
                                        <template #no-options="{ search, searching, loading }">
                                            {{ SELECT_NOT_FOUND }}
                                        </template>
                                        <template #open-indicator="{ attributes }">
                                            <span v-bind="attributes">
                                                <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                            </span>
                                        </template>
                                    </v-select>
                                </div>
                            </el-col>

                            <el-col :span="6" class="documents-page-head__grow">
                                <div class="documents-page-head__extra">
                                    <form
                                        class="search-form wizard-step-head__grow"
                                        @submit.prevent
                                    >
                                        <div class="search-form__inner">
                                            <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': searchInput && searchInput.length !== 0 }" placeholder="Поиск" :disabled="!mockData.length" v-model.trim="searchInput" @keydown.enter.prevent.stop>

                                            <button v-if="searchInput && searchInput.length !== 0" class="search-form__reset" @click="searchInput = ''">
                                                <icon-base viewBox="0 0 14 14"><icon-cancel /></icon-base>
                                            </button>

                                            <button type="submit" class="search-form__submit">
                                                <icon-base viewBox="0 0 24 24"><icon-search /></icon-base>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>

            <div class="container">
                <div class="documents-page-body">
                    <el-table
                        cell-class-name="table__cell"
                        class="table"
                        header-cell-class-name="table__title"
                        ref="table"
                        row-key="id"
                        :data="filteredBySearch"
                        :sort-orders="['ascending', 'descending']"
                    >
                        <el-table-column
                            label="Название документа"
                            prop="name"
                            sortable
                            :min-width="400"
                        >
                          <template slot-scope="scope">
                              <a href="#" @click.prevent.stop="downloadDocument(scope.row.id)">
                                {{ scope.row.name }}
                              </a>
                          </template>
                        </el-table-column>
                        <el-table-column
                            label="Дата создания"
                            prop="data"
                            sortable
                            :min-width="80"
                        >
                        </el-table-column>
                        <el-table-column
                            label="Тип файла"
                            prop="mymeType"
                            align="center"
                            sortable
                            :min-width="50"
                        >
                        </el-table-column>
                        <el-table-column
                            label="Размер файла"
                            prop="weight"
                            align="center"
                            sortable
                            :min-width="60"
                        >
                        </el-table-column>
                        <el-table-column
                            align="center"
                            width="48"
                        >
                            <template slot-scope="scope">
                                <el-tooltip content="Скачать документ" placement="bottom-end">
                                    <a href="#" class="table__info" @click.prevent.stop="downloadDocument(scope.row.id)">
                                        <icon-base viewBox="0 0 21 20" width="21" height="20">
                                            <icon-cloud />
                                        </icon-base>
                                    </a>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </el-main>
</template>

<script>

import constants from '@/constants.js';
import { getFullUrl } from '@/helpers';

export default {
    data() {
        return {
            curType: '',
            searchInput: '',

            documentTypes: [
                'Все',
                'Нормативно-правовые акты',
                'Методические материалы'
            ],
            mockData: [
                {
                    id: 1,
                    name: 'Рекомендации по формированию отраслевых рамок квалификаций в программно-методическом комплексе «Разработка квалификаций»',
                    documentType: 'Нормативно-правовые акты',
                    data: '16 сентября 2020',
                    mymeType: 'PDF',
                    url: 'storage/documents/rekomendacii_po_formirovaniyu.pdf',
                    weight: '4 мб'
                },
                {
                    id: 2,
                    name: 'Методические рекомендации по разработке отраслевых рамок квалификаций, пакетной разработке профессиональных стандартов, квалификаций и спецификаций оценочных средств',
                    data: '16 июня 2020',
                    documentType: 'Нормативно-правовые акты',
                    mymeType: 'PDF',
                    url: 'storage/documents/metodicheskie_rekomendacii.pdf',
                    weight: '4 мб'
                },
                {
                    id: 3,
                    name: 'Приказ Минтруда России от 30.09.2014 N 671н "Об утверждении методических рекомендаций по организации профессионально-общественного обсуждения и экспертизы проектов профессиональных стандартов"',
                    documentType: 'Методические материалы',
                    data: '16 июня 2020',
                    mymeType: 'PDF',
                    url: 'storage/documents/prikaz.pdf',
                    weight: '4 мб'
                },
                {
                    id: 4,
                    name: 'Руководство пользователя по разработке отраслевых рамок квалификаций в программно-методическом комплексе «Разработка квалификаций',
                    documentType: 'Методические материалы',
                    data: '16 июня 2020',
                    mymeType: 'PDF',
                    url: 'storage/documents/rukovodstvo_polzovatelya_ork_2022.pdf',
                    weight: '4 мб'
                },
                {
                    id: 5,
                    name: 'Лифлет_Рекомендации для разработчиков профессиональных стандартов, квалификаций и оценочных средств',
                    documentType: 'Методические материалы',
                    data: '16 июня 2020',
                    mymeType: 'PDF',
                    url: 'storage/documents/Лифлет_1_ОРК_.pdf',
                    weight: '4 мб'
                },
                {
                    id: 6,
                    name: 'Лифлет_Цифровой модуль "Разработка отраслевых рамок квалификаций"',
                    documentType: 'Методические материалы',
                    data: '16 июня 2020',
                    mymeType: 'PDF',
                    url: 'storage/documents/Лифлет_2_ОРК IT_фин.pdf',
                    weight: '4 мб'
                },
            ]
        }
    },
    methods: {
        downloadDocument(id) {
            console.log('download Document');
            const file = this.mockData.find(item => item.id === id);
            window.open(getFullUrl(file.url))
        },
    },
    computed: {
        filteredByType() {
            return this.curType && this.curType !== 'Все' ? this.mockData.filter(item => item.documentType === this.curType) : this.mockData
        },

        filteredBySearch() {
            return this.searchInput ? this.filteredByType.filter(item => item.name.toLowerCase().includes(this.searchInput.toLowerCase())) : this.filteredByType
        }
    },
    created() {
        this.STATUSES_DICT = constants.STATUSES_DICT;
    },
}
</script>
